import {API_URL, apiPut} from '../api'

export const editCampaign = async data => {
    return await apiPut(API_URL, 'admin/campaign', data)
}
